// src/pages/ForgotPasswordPage.js
import React, { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import AuthLayout from '../components/auth/AuthLayout';
import '../components/css/ForgotPasswordPage.css';


const ForgotPasswordPage = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setMessage('');
    setIsError(false);
    setLoading(true);

    // --- Replace with your actual API call ---
    console.log("Requesting password reset for:", email);
    // const response = await fetch('https://bookmyaudition.com/auth/forgot_password', {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    //   body: new URLSearchParams({ login: email }) // 'login' is the name in original form
    // });
    // const data = await response.json(); // Or .text() if HTML response
    // if (response.ok && data.success) { // Adjust based on API
    //   setMessage('If an account exists for this email, a password reset link has been sent.');
    // } else {
    //   setMessage(data.message || 'Failed to send reset link. Please try again.');
    //   setIsError(true);
    // }
    // --- End API call ---

    // Mock
    setTimeout(() => {
      if (email.includes('@')) {
        setMessage('If an account exists for this email, a password reset link has been sent (mock).');
        setIsError(false);
      } else {
        setMessage('Please enter a valid email address (mock error).');
        setIsError(true);
      }
      setLoading(false);
    }, 1000);
  };

  return (
    <AuthLayout
      pageTitle="Forgot Password - BOOKMYAUDITION"
      metaDescription="Reset your BOOKMYAUDITION account password."
      sidebarTitle="FORGOT PASSWORD"
      sidebarText="Don't Worry. We've got you back."
      sidebarLink="/register" // Or /login
      sidebarLinkText="Register" // Or "Back to Login"
       className="forgot-password-auth-layout" 
    >
      <Form onSubmit={handleForgotPassword}>
        {message && <Alert variant={isError ? "danger" : "success"} className="py-2 small">{message}</Alert>}
        <Form.Group className="mb-4" controlId="forgotEmail"> {/* mb-30 in original */}
          <Form.Control
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="form-ctrl-login-custom"
          />
        </Form.Group>

        <Button variant="outline-dark" type="submit" className="w-100 btn-lg text-uppercase" disabled={loading}  style={{ color: "#fff", borderColor: "#495057" ,background: "linear-gradient(135deg, #c30000 0%, #b33a3a 100%)"}}>
          {loading ? 'Sending...' : 'Get a new password'}
        </Button>

        <div className="d-md-none mt-4 text-center">
          <p className="font-12-custom text-white">Remembered your password?</p>
          <Link to="/login" className="btn btn-outline-light btn-lg d-block view_detail_btn_fff_custom text-uppercase">
            Login
          </Link>
        </div>
      </Form>
    </AuthLayout>
  );
};

export default ForgotPasswordPage;